import React, { useEffect, useRef, useState } from "react";
import {
  getCourseCategories,
  getCourses,
  getExam,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const CollegeUniversityStep11 = ({
  data,
  setData,
  setCurrentStep,
  currentStep,
}) => {
  const initialValues = {
    cutOffHeading: data?.cutOffHeading,
    cutOffText: data?.cutOffText,
    cutOffItems: data?.cutOffItems,
  };
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1);
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    // setCurrentStep(currentStep + 1)

    // const customizedData = {
    //   ...formData,
    //   cutOffItems: formData.cutOffItems.map(({ courseCategory, ...rest }) => rest)
    // };
    console.log("FGS46", formData);

    // return
    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues);
        setFormDataLoading(false);
        setData({
          ...data,
          cutOffHeading: formData?.cutOffHeading,
          cutOffText: formData?.cutOffText,
          cutOffItems: formData?.cutOffItems,
        });
        setCurrentStep(currentStep + 1);
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  /// Examination /////
  const [examinations, setExaminations] = useState([]);

  const fetchExaminationations = async () => {
    try {
      const res = await getExam();
      console.log("fetched examinations", res?.data);
      if (res?.status) {
        setExaminations(res?.data);
      } else {
        toast.error("Error while Fetching Examinations Data");
      }
    } catch (error) {
      toast.error("failed to fetch Examinations Data");
      console.error("Error fetching Examinations Data:", error);
    }
  };

  //// Course & Category /////
  const [courseCategories, setCourseCategories] = useState([]);
  const [courses, setCourses] = useState([]);

  const fetchCourseCategories = async () => {
    try {
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
      } else {
        toast.error("Error while Fetching Course Categories Data");
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        const retVal = res?.data.filter(
          (item) => item.categoryId === categoryId
        );
        return retVal;
        // setCourses(val);
      } else {
        toast.error("Error while Fetching Courses Data");
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
    }
  };

  /////////////////////////////////////
  const initialItem = {
    courseCategory: "",
    courseId: "",
    examName: "",
    openingRank: "",
    closingRank: "",
  };
  const [courseList, setCourseList] = useState([]);

  const initialItems = data?.cutOffItems.length
    ? data?.cutOffItems
    : [initialItem];
  console.log("LKI124", initialItems);

  const [items, setItems] = useState(initialItems);
  const handleMultiChange = async (i, e) => {
    let newFormValues = [...items];
    newFormValues[i][e.target.name] = e.target.value;
    setItems(newFormValues);
    setFormData({ ...formData, cutOffItems: newFormValues });

    if (e.target.name === "courseCategory") {
      const courseOptions = await fetchCourses(e.target.value);
      console.log("MJY117", courseOptions);
      if (courseList.length > i) {
        setCourseList((prev) => {
          const updated = [...prev];
          updated[i] = courseOptions;
          return updated;
        });
      } else {
        setCourseList([...courseList, courseOptions]);
      }
    }
  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, cutOffItems: newFormValues });
  };

  const populateCourseOptions = async () => {
    try {
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        // setCourses(res?.data);
        const allAvailableCourses = res?.data;
        console.log("DER188", allAvailableCourses, initialItems);
        initialItems.map((item, i) => {
          const courseCategoryId =
            item?.courseCategory || item?.courseCategory?._id;
          console.log("CDE181", allAvailableCourses, courseCategoryId);

          const courseOptions = allAvailableCourses.filter(
            (c) => c.categoryId === courseCategoryId
          );
          console.log("CDE167", courseOptions, i);
          setCourseList((prev) => {
            const updated = [...prev];
            updated[i] = courseOptions;
            return updated;
          });
        });
      } else {
        toast.error("Error while Fetching Courses Data");
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
    }
  };

  console.log("KIU215", courseList);

  ///// ***** ////
  useEffect(() => {
    fetchCourseCategories();
    populateCourseOptions();
    fetchExaminationations();
  }, []);

  useEffect(() => {
    setFormData(initialValues);
  }, [data]);

  return (
    <>
      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">
            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Cut Off Heading<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.cutOffHeading}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    cutOffHeading: e?.target?.value,
                  }));
                }}
                placeholder="Enter Heading Text"
              />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                Cut Off Information <span className="text-danger">*</span>
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.cutOffText || ""}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    cutOffText: value,
                  }));
                }}
                placeholder="Enter Long Description"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem",
                }}
              />
            </div>

            <div className="col-md-12 mt-3">
              <label>
                Placements{" "}
                <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => addItem()}
                >
                  <i class="fas fa-plus"></i> Add
                </button>
              </label>
              {items?.map((element, index) => (
                <div
                  // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                  className="_form-inline row"
                  key={index}
                >
                  <div className="col-md-3 mb-2 mt-1">
                    <label>Category:</label>
                    <select
                      name="courseCategory"
                      onChange={(e) => handleMultiChange(index, e)}
                      value={element?.courseCategory}
                      className="form-control"
                    >
                      <option value="">--- Choose ---</option>
                      {courseCategories.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-3 mb-2 mt-1">
                    <label>Course:</label>
                    <select
                      name="courseId"
                      onChange={(e) => handleMultiChange(index, e)}
                      value={element?.courseId}
                      className="form-control"
                    >
                      <option value="">--- Choose ---</option>
                      {courseList[index]?.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.degreeName}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>Examination:</label>
                    {/* <input
                      type="text"
                      class="form-control"
                      name="examName"
                      placeholder={`Exam ${index + 1}`}
                      value={element.examName || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    /> */}
                    <select
                      className="form-control"
                      onChange={(e) => handleMultiChange(index, e)}
                      name="examName"
                      id=""
                      value={element?.examName || ""}
                    >
                      <option>--Select Exam--</option>
                      {examinations?.length == 0 ? (
                        <option>No Examination Found</option>
                      ) : (
                        examinations?.map((e, i) => {
                          return <option value={e?._id}>{e?.name}</option>;
                        })
                      )}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>Opening Rank:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="openingRank"
                      placeholder={`Rank ${index + 1}`}
                      value={element.openingRank || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>Closing Rank:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="closingRank"
                      placeholder={`Rank ${index + 1}`}
                      value={element.closingRank || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  {index ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "25px",
                      }}
                    >
                      <i
                        class="fas fa-times"
                        style={{
                          color: "#ff0000",
                          cursor: "pointer",
                          fontSize: "1em",
                        }}
                        onClick={() => removeProducts(index)}
                      ></i>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
          <div className=" d-flex justify-content-end">
            {currentStep > 2 && (
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px",
                }}
                onClick={(e) => handleBack(e)}
              >
                Back
              </button>
            )}

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                : // : "Add College/University"
                  `Save & Continue`}
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default CollegeUniversityStep11;
